/**
 * Dane masowe dla Mercedes Benz Tourist Line HighDeck, zależne od kodu wersji
 * pojazdu ({{version}}). Źródło: tabela dostarczona przez klienta (kolumny
 * 2.6.1 "Axle 1/Axle 2 [kg]" i 2.6 "[kg]" - Mass in running order).
 *
 * Z tabeli wyliczane są wyłącznie 3 wartości (Sekcja 13 - Mass in running order),
 * tak samo jak dla Iveco (patrz iveco-mass-data.ts):
 * - {{massInRunningOrder}} = kolumna "2.6" (wartość max)
 * - {{massAxle2}}          = kolumna "Axle 2" (wartość max)
 * - {{massAxle1}}          = {{massInRunningOrder}} - {{massAxle2}} (wyliczane)
 *
 * Wartości min są przechowywane wyłącznie jako zakres referencyjny do
 * wyświetlenia w tooltipie - nie są wpisywane do formularza.
 *
 * W przeciwieństwie do tabeli Iveco, źródło nie ma osobnej kolumny liczby
 * stojących pasażerów - każdy kod wersji ({{version}}) w tabeli jest unikalny
 * i jednoznacznie wyznacza wpis, dlatego wszystkie wpisy są pod kluczem "*".
 * Kolumny "Volume of luggage" i "Max. mass of luggage" nie są tu potrzebne
 * (nie są używane przy wypełnianiu żadnego pola dokumentu), więc - podobnie
 * jak w przypadku tabeli Iveco - zostały pominięte.
 *
 * Tabela obejmuje warianty "NR" i "P/PR" (pilotka) oraz dwa tonaże: "62"
 * (Type 906BA/BB50, rozstawy W05-W09, W15) i "68" (Type 906CA55, rozstawy
 * W10-W14) - klucz wersji jednoznacznie koduje oba te wymiary, więc nie
 * potrzeba osobnej logiki dopasowania tonażu (w przeciwieństwie do Iveco
 * "8X" - patrz expandIvecoVersionCandidates w iveco-mass-data.ts).
 *
 * Kilka wierszy w źródle miało uszkodzone (nieczytelne, resztki OCR) wartości
 * w kolumnach "Volume of luggage"/"Max. mass of luggage" - że kolumny te
 * i tak nie są tu zapisywane, nie ma to znaczenia dla poprawności danych
 * poniżej (dotyczy tylko kolumn pominiętych).
 *
 * @module mercedes-tourist-line-highdeck-mass-data
 */

import type { VersionMassDataTable } from "./vehicle-mass-data";

export const MERCEDES_TOURIST_LINE_HIGHDECK_MASS_DATA: VersionMassDataTable = {
  "62W05NR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2596,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4496,
    },
  },
  "62W06NR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2803,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4703,
    },
  },
  "62W07NR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1954,
      axle2Min: 1900,
      axle2Max: 3010,
      massInRunningOrderMin: 3765,
      massInRunningOrderMax: 4964,
    },
  },
  "62W08NR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1887,
      axle2Min: 2091,
      axle2Max: 3290,
      massInRunningOrderMin: 3978,
      massInRunningOrderMax: 5177,
    },
  },
  "62W09NR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1970,
      axle2Min: 1900,
      axle2Max: 2994,
      massInRunningOrderMin: 3765,
      massInRunningOrderMax: 4964,
    },
  },
  "62W05NR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2457,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4357,
    },
  },
  "62W06NR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2664,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4564,
    },
  },
  "62W07NR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1993,
      axle2Min: 1900,
      axle2Max: 2871,
      massInRunningOrderMin: 3665,
      massInRunningOrderMax: 4864,
    },
  },
  "62W08NR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1925,
      axle2Min: 1953,
      axle2Max: 3152,
      massInRunningOrderMin: 3878,
      massInRunningOrderMax: 5077,
    },
  },
  "62W09NR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1999,
      axle2Min: 1900,
      axle2Max: 2855,
      massInRunningOrderMin: 3655,
      massInRunningOrderMax: 4854,
    },
  },
  "62W05NR3L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2319,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4219,
    },
  },
  "62W06NR3L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2525,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4425,
    },
  },
  "62W07NR3L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1999,
      axle2Min: 1900,
      axle2Max: 2732,
      massInRunningOrderMin: 3532,
      massInRunningOrderMax: 4731,
    },
  },
  "62W08NR3L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1964,
      axle2Min: 1900,
      axle2Max: 3013,
      massInRunningOrderMin: 3778,
      massInRunningOrderMax: 4977,
    },
  },
  "62W09NR3L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1999,
      axle2Min: 1900,
      axle2Max: 2717,
      massInRunningOrderMin: 3517,
      massInRunningOrderMax: 4716,
    },
  },
  "62W05NR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2554,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4454,
    },
  },
  "62W06NR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2761,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4661,
    },
  },
  "62W07NR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1926,
      axle2Min: 1900,
      axle2Max: 2968,
      massInRunningOrderMin: 3695,
      massInRunningOrderMax: 4894,
    },
  },
  "62W08NR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1858,
      axle2Min: 2050,
      axle2Max: 3249,
      massInRunningOrderMin: 3908,
      massInRunningOrderMax: 5107,
    },
  },
  "62W09NR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1942,
      axle2Min: 1900,
      axle2Max: 2952,
      massInRunningOrderMin: 3695,
      massInRunningOrderMax: 4894,
    },
  },
  "62W05NR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2416,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4316,
    },
  },
  "62W06NR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2623,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4523,
    },
  },
  "62W07NR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1965,
      axle2Min: 1900,
      axle2Max: 2829,
      massInRunningOrderMin: 3595,
      massInRunningOrderMax: 4794,
    },
  },
  "62W08NR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1897,
      axle2Min: 1911,
      axle2Max: 3110,
      massInRunningOrderMin: 3808,
      massInRunningOrderMax: 5007,
    },
  },
  "62W09NR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1980,
      axle2Min: 1900,
      axle2Max: 2814,
      massInRunningOrderMin: 3595,
      massInRunningOrderMax: 4794,
    },
  },
  "62W05NR3L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2277,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4177,
    },
  },
  "62W06NR3L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2484,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4384,
    },
  },
  "62W07NR3L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1999,
      axle2Min: 1900,
      axle2Max: 2691,
      massInRunningOrderMin: 3491,
      massInRunningOrderMax: 4690,
    },
  },
  "62W08NR3L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1936,
      axle2Min: 1900,
      axle2Max: 2971,
      massInRunningOrderMin: 3708,
      massInRunningOrderMax: 4907,
    },
  },
  "62W09NR3L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1999,
      axle2Min: 1900,
      axle2Max: 2675,
      massInRunningOrderMin: 3475,
      massInRunningOrderMax: 4674,
    },
  },
  "62W05NR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1885,
      axle2Min: 1900,
      axle2Max: 2513,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4398,
    },
  },
  "62W06NR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1891,
      axle2Min: 1900,
      axle2Max: 2720,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4611,
    },
  },
  "62W07NR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1897,
      axle2Min: 1900,
      axle2Max: 2927,
      massInRunningOrderMin: 3625,
      massInRunningOrderMax: 4824,
    },
  },
  "62W08NR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1830,
      axle2Min: 2008,
      axle2Max: 3207,
      massInRunningOrderMin: 3838,
      massInRunningOrderMax: 5037,
    },
  },
  "62W09NR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1913,
      axle2Min: 1900,
      axle2Max: 2911,
      massInRunningOrderMin: 3625,
      massInRunningOrderMax: 4824,
    },
  },
  "62W05NR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2374,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4274,
    },
  },
  "62W06NR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2581,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4481,
    },
  },
  "62W07NR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1936,
      axle2Min: 1900,
      axle2Max: 2788,
      massInRunningOrderMin: 3525,
      massInRunningOrderMax: 4724,
    },
  },
  "62W08NR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1868,
      axle2Min: 1900,
      axle2Max: 3069,
      massInRunningOrderMin: 3738,
      massInRunningOrderMax: 4937,
    },
  },
  "62W09NR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1952,
      axle2Min: 1900,
      axle2Max: 2772,
      massInRunningOrderMin: 3525,
      massInRunningOrderMax: 4724,
    },
  },
  "62W05NR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2235,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4135,
    },
  },
  "62W06NR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2442,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4342,
    },
  },
  "62W07NR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1975,
      axle2Min: 1900,
      axle2Max: 2649,
      massInRunningOrderMin: 3425,
      massInRunningOrderMax: 4624,
    },
  },
  "62W08NR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1907,
      axle2Min: 1900,
      axle2Max: 2930,
      massInRunningOrderMin: 3638,
      massInRunningOrderMax: 4837,
    },
  },
  "62W09NR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1991,
      axle2Min: 1900,
      axle2Max: 2633,
      massInRunningOrderMin: 3425,
      massInRunningOrderMax: 4624,
    },
  },
  "62W15NR3L2M1": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1977,
      axle2Min: 1900,
      axle2Max: 3146,
      massInRunningOrderMin: 3724,
      massInRunningOrderMax: 4923,
    },
  },
  // Warianty "P" (z pilotką) - odpowiedniki wierszy NR wyżej, tonaż 62
  "62W05PR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2544,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4444,
    },
  },
  "62W06PR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2751,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4651,
    },
  },
  "62W07PR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1931,
      axle2Min: 1900,
      axle2Max: 2958,
      massInRunningOrderMin: 3690,
      massInRunningOrderMax: 4889,
    },
  },
  "62W08PR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1864,
      axle2Min: 2039,
      axle2Max: 3238,
      massInRunningOrderMin: 3903,
      massInRunningOrderMax: 5102,
    },
  },
  "62W09PR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1947,
      axle2Min: 1900,
      axle2Max: 2942,
      massInRunningOrderMin: 3690,
      massInRunningOrderMax: 4889,
    },
  },
  "62W05PR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2405,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4305,
    },
  },
  "62W06PR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2612,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4512,
    },
  },
  "62W07PR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1970,
      axle2Min: 1900,
      axle2Max: 2819,
      massInRunningOrderMin: 3590,
      massInRunningOrderMax: 4789,
    },
  },
  "62W08PR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1902,
      axle2Min: 1901,
      axle2Max: 3100,
      massInRunningOrderMin: 3803,
      massInRunningOrderMax: 5002,
    },
  },
  "62W09PR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1986,
      axle2Min: 1900,
      axle2Max: 2803,
      massInRunningOrderMin: 3590,
      massInRunningOrderMax: 4789,
    },
  },
  "62W05PR3L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2267,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4167,
    },
  },
  "62W06PR3L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2473,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4373,
    },
  },
  "62W07PR3L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1999,
      axle2Min: 1900,
      axle2Max: 2680,
      massInRunningOrderMin: 3480,
      massInRunningOrderMax: 4679,
    },
  },
  "62W08PR3L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1941,
      axle2Min: 1900,
      axle2Max: 2961,
      massInRunningOrderMin: 3703,
      massInRunningOrderMax: 4902,
    },
  },
  "62W09PR3L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1999,
      axle2Min: 1900,
      axle2Max: 2665,
      massInRunningOrderMin: 3465,
      massInRunningOrderMax: 4664,
    },
  },
  "62W05PR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1891,
      axle2Min: 1900,
      axle2Max: 2502,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4393,
    },
  },
  "62W06PR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1897,
      axle2Min: 1900,
      axle2Max: 2709,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4606,
    },
  },
  "62W07PR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1903,
      axle2Min: 1900,
      axle2Max: 2916,
      massInRunningOrderMin: 3620,
      massInRunningOrderMax: 4819,
    },
  },
  "62W08PR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1835,
      axle2Min: 1998,
      axle2Max: 3197,
      massInRunningOrderMin: 3833,
      massInRunningOrderMax: 5032,
    },
  },
  "62W09PR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1919,
      axle2Min: 1900,
      axle2Max: 2900,
      massInRunningOrderMin: 3620,
      massInRunningOrderMax: 4819,
    },
  },
  "62W05PR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2364,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4264,
    },
  },
  "62W06PR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2571,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4471,
    },
  },
  "62W07PR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1942,
      axle2Min: 1900,
      axle2Max: 2777,
      massInRunningOrderMin: 3520,
      massInRunningOrderMax: 4719,
    },
  },
  "62W08PR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1874,
      axle2Min: 1900,
      axle2Max: 3058,
      massInRunningOrderMin: 3733,
      massInRunningOrderMax: 4932,
    },
  },
  "62W09PR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1957,
      axle2Min: 1900,
      axle2Max: 2762,
      massInRunningOrderMin: 3520,
      massInRunningOrderMax: 4719,
    },
  },
  "62W05PR3L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2225,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4125,
    },
  },
  "62W06PR3L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2432,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4332,
    },
  },
  "62W07PR3L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1980,
      axle2Min: 1900,
      axle2Max: 2639,
      massInRunningOrderMin: 3420,
      massInRunningOrderMax: 4619,
    },
  },
  "62W08PR3L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1913,
      axle2Min: 1900,
      axle2Max: 2919,
      massInRunningOrderMin: 3633,
      massInRunningOrderMax: 4832,
    },
  },
  "62W09PR3L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1996,
      axle2Min: 1900,
      axle2Max: 2623,
      massInRunningOrderMin: 3420,
      massInRunningOrderMax: 4619,
    },
  },
  "62W05PR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1862,
      axle2Min: 1900,
      axle2Max: 2461,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4323,
    },
  },
  "62W06PR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1868,
      axle2Min: 1900,
      axle2Max: 2668,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4536,
    },
  },
  "62W07PR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1874,
      axle2Min: 1900,
      axle2Max: 2875,
      massInRunningOrderMin: 3550,
      massInRunningOrderMax: 4749,
    },
  },
  "62W08PR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1807,
      axle2Min: 1956,
      axle2Max: 3155,
      massInRunningOrderMin: 3763,
      massInRunningOrderMax: 4962,
    },
  },
  "62W09PR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1890,
      axle2Min: 1900,
      axle2Max: 2859,
      massInRunningOrderMin: 3550,
      massInRunningOrderMax: 4749,
    },
  },
  "62W05PR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2322,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4222,
    },
  },
  "62W06PR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2529,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4429,
    },
  },
  "62W07PR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1913,
      axle2Min: 1900,
      axle2Max: 2736,
      massInRunningOrderMin: 3450,
      massInRunningOrderMax: 4649,
    },
  },
  "62W08PR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1845,
      axle2Min: 1900,
      axle2Max: 3017,
      massInRunningOrderMin: 3663,
      massInRunningOrderMax: 4862,
    },
  },
  "62W09PR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1929,
      axle2Min: 1900,
      axle2Max: 2720,
      massInRunningOrderMin: 3450,
      massInRunningOrderMax: 4649,
    },
  },
  "62W05PR3L2M0": {
    "*": {
      axle1RangeMin: 1317,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2183,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4083,
    },
  },
  "62W06PR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 1900,
      axle2Max: 2390,
      massInRunningOrderMin: 3500,
      massInRunningOrderMax: 4290,
    },
  },
  "62W07PR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1952,
      axle2Min: 1900,
      axle2Max: 2597,
      massInRunningOrderMin: 3350,
      massInRunningOrderMax: 4549,
    },
  },
  "62W08PR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1884,
      axle2Min: 1900,
      axle2Max: 2878,
      massInRunningOrderMin: 3563,
      massInRunningOrderMax: 4762,
    },
  },
  "62W09PR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1968,
      axle2Min: 1900,
      axle2Max: 2581,
      massInRunningOrderMin: 3350,
      massInRunningOrderMax: 4549,
    },
  },
  "62W15PR3L2M1": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1926,
      axle2Min: 1900,
      axle2Max: 3122,
      massInRunningOrderMin: 3649,
      massInRunningOrderMax: 4848,
    },
  },
  // Tonaż 68 (Type: 906CA55) - rozstawy W10-W14
  "68W10PR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3050,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4723,
    },
  },
  "68W10NR3L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3050,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4798,
    },
  },
  "68W11NR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3200,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4750,
    },
  },
  "68W11NR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3107,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4750,
    },
  },
  "68W11NR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3200,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4750,
    },
  },
  "68W11NR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3065,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4684,
    },
  },
  "68W11NR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3163,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4714,
    },
  },
  "68W11NR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3024,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4614,
    },
  },
  "68W12NR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3250,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4818,
    },
  },
  "68W12NR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3246,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4818,
    },
  },
  "68W12NR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3250,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4818,
    },
  },
  "68W12NR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3204,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4818,
    },
  },
  "68W12NR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3250,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4818,
    },
  },
  "68W12NR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3163,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4756,
    },
  },
  "68W12PR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3250,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4784,
    },
  },
  "68W12PR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3222,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4784,
    },
  },
  "68W12PR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3250,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4784,
    },
  },
  "68W12PR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3180,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4755,
    },
  },
  "68W12PR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3220,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4784,
    },
  },
  "68W12PR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3139,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4685,
    },
  },
  "68W13NR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3250,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4818,
    },
  },
  "68W13NR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3250,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4818,
    },
  },
  "68W13NR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3250,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4818,
    },
  },
  "68W13NR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3218,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4818,
    },
  },
  "68W13NR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3250,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4818,
    },
  },
  "68W13NR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3177,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4756,
    },
  },
  "68W14NR1L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3200,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4750,
    },
  },
  "68W14NR2L0M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3116,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4750,
    },
  },
  "68W14NR1L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3200,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4750,
    },
  },
  "68W14NR2L1M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3074,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4684,
    },
  },
  "68W14NR1L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3171,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4714,
    },
  },
  "68W14NR2L2M0": {
    "*": {
      axle1RangeMin: 1300,
      axle1RangeMax: 1900,
      axle2Min: 2000,
      axle2Max: 3033,
      massInRunningOrderMin: 3900,
      massInRunningOrderMax: 4614,
    },
  },
};
